import { Injectable } from '@angular/core';
   
import { IndividualConfig, ToastrService } from 'ngx-toastr';
   
@Injectable({
  providedIn: 'root'
})
export class NotificationsToastService {
  showInfoExtended(message, title){
    this.toastr.toastrConfig.timeOut=30000;
    this.toastr.toastrConfig.tapToDismiss=false;  
    this.toastr.info(message, title)
  }

  showRealTime(message: string, title: string) {
    this.toastr.toastrConfig.timeOut=4000;
    this.toastr.toastrConfig.tapToDismiss=false;
      this.toastr.info(message, title)
  }
  showDisconnectRealTime(message: string, title: string) {
    this.toastr.toastrConfig.timeOut=2000;
    this.toastr.toastrConfig.tapToDismiss=false;
    this.toastr.warning(message, title)
  }
   
  constructor(private toastr: ToastrService) { }
   
  showSuccess(message, title){
    this.toastr.toastrConfig.timeOut=3000;
    this.toastr.toastrConfig.tapToDismiss=false;
      this.toastr.success(message, title)
  }
   
  showError(message, title){
    this.toastr.toastrConfig.timeOut=3000;
    this.toastr.toastrConfig.tapToDismiss=false;
      this.toastr.error(message, title)
  }

  showErrorSystem(){
    this.toastr.toastrConfig.timeOut=15000;
    this.toastr.error("Servicio no disponible, contacte al administrador o inténtelo más tarde","Falla al conectar con el servidor");
  }
   
  showInfo(message, title){
    this.toastr.toastrConfig.timeOut=3000;
    this.toastr.toastrConfig.tapToDismiss=false;  
    this.toastr.info(message, title)
  }
   
  showWarning(message, title){
    this.toastr.toastrConfig.timeOut=3000;
    this.toastr.toastrConfig.tapToDismiss=false;
      this.toastr.warning(message, title)
  }

  showCustomToast(notificationDTO: any) {
    // Configuración personalizada del toast
    const config: Partial<IndividualConfig> = {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: true,
      enableHtml: true, 
      toastClass: `ngx-toastr custom-toast toast-${notificationDTO.Priority}`,
      positionClass: 'toast-top-right'
    };

    let toastTitle = 'Alarma de '+ notificationDTO.NotificationCategory;
    let toastMessage = notificationDTO.IdNotificationCategory == 1 ? notificationDTO.detonatorName + " - " + notificationDTO.Identifier : "ID " + notificationDTO.Identifier;

    // Muestra el toast con configuración personalizada
    this.toastr.show(toastMessage, toastTitle, config);
  }
   

}